import React from "react";
import { motion } from "framer-motion";
import { Sun, Book, Heart, Sparkles, Star } from "lucide-react";

import IMG1 from "../assets/baceweb.jpg";
import IMGM from "../assets/img2.jpg";
import IMGC from "../assets/img10.jpg";
import IMGSB from "../assets/img7.jpg";
import GaurPurnima from "../assets/Gaurpurnima.jpg";
import punyatithi from "../assets/punyatithi.jpg";
import srikrishnajanmastami from "../assets/janmastami.jpg";
import FreeClasses from "../assets/Activity1.jpg";

const programs = [
  { img: IMG1, title: "Mangla Aarti", icon: <Sun size={22} /> },
  { img: IMGM, title: "Gaura Aarti", icon: <Sparkles size={22} /> },
  { img: IMGSB, title: "Sunday BG Class", icon: <Book size={22} /> },
  { img: IMGC, title: "Village SB Class", icon: <Book size={22} /> },
  {
    img: GaurPurnima,
    title: "Gaura Purnima Program",
    icon: <Star size={22} />,
  },
  {
    img: punyatithi,
    title: "Mataji Punyatithi Program",
    icon: <Heart size={22} />,
  },
  {
    img: srikrishnajanmastami,
    title: "Shri Krishna Janmashtami",
    icon: <Sparkles size={22} />,
  },
  {
    img: FreeClasses,
    title: "Free Coaching Classes",
    icon: <Book size={22} />,
  },
];

const Program = () => {
  return (
    <section className="py-24 px-6 bg-gradient-to-b from-[#fff4e3] to-[#fffaf0] border-t border-amber-100">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true }}
        className="max-w-7xl mx-auto flex flex-col items-center"
      >
        {/* Header */}
        <span className="text-amber-800 font-semibold text-xs tracking-[0.2em] uppercase mb-2 block text-center">
          Our Initiatives
        </span>
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-amber-900 mb-14 text-center tracking-wide">
          🪔 RKGVK Core Programs 🪔
        </h2>

        {/* Grid of Programs */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 w-full mt-4">
          {programs.map((item, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.08 }}
              viewport={{ once: true }}
              className="group relative flex flex-col items-center text-center rounded-3xl shadow-md hover:shadow-xl bg-white overflow-hidden hover:scale-[1.03] transition-all duration-500 border border-amber-100/50"
            >
              {/* Image */}
              <div className="relative overflow-hidden w-full h-72">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover transform group-hover:scale-105 transition duration-700 ease-out"
                />
                {/* Gradient overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-amber-950/60 via-transparent to-transparent opacity-60 group-hover:opacity-80 transition duration-500"></div>
              </div>

              {/* Title - Frosted Glass Banner */}
              <div className="absolute bottom-0 left-0 right-0 py-4 bg-amber-950/80 backdrop-blur-md text-[#ffd27f] border-t border-[#ffd27f]/10 font-serif font-bold text-md tracking-wider flex items-center justify-center gap-2 shadow-md transition-all duration-500 group-hover:bg-[#ffd27f] group-hover:text-amber-950 group-hover:border-amber-950/20">
                <span className="text-amber-400 group-hover:text-amber-950 transition-colors">{item.icon}</span>
                {item.title}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Program;
